import { Box, Typography } from '@mui/material';

const TAB_LABELS = {
  mart: 'Mart',
  store: 'Store',
  passes: 'Passes',
};

const TAB_ORDER = ['mart', 'store', 'passes'];

const tabNavSx = {
  position: 'relative',
  display: 'flex',
  p: '3px',
  mb: 1.1,
  mx: 'auto',
  width: '100%',
  maxWidth: { xs: 400, sm: 430, md: 730 },
  height: 52,
  borderRadius: '30px',
  background: 'linear-gradient(180deg, #6611a5 0%, #4d067f 45%, #2d0149 100%)',
  border: '1px solid rgba(255, 255, 255, 0.12)',
  boxShadow:
    'inset 0 2px 0 rgba(255, 255, 255, 0.18), inset 0 -2px 0 rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(173, 58, 255, 0.45), 0 6px 16px rgba(0, 0, 0, 0.45)',
  overflow: 'visible',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 1,
    left: 8,
    right: 8,
    height: '45%',
    borderRadius: '30px',
    background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0))',
    pointerEvents: 'none',
  },
};

const tabBaseSx = {
  flex: 1,
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: 0,
  bgcolor: 'transparent',
  cursor: 'pointer',
  borderRadius: '24px',
  fontFamily: 'inherit',
  minWidth: 0,
  transition: 'background 0.2s ease',
  '&:hover': {
    bgcolor: 'rgba(255, 255, 255, 0.05)',
  },
};

const tabActiveSx = {
  background: 'linear-gradient(180deg, #ff4cff 0%, #df18ff 55%, #9c0eff 100%)',
  boxShadow:
    'inset 0 2px 2px rgba(255, 255, 255, 0.35), inset 0 -3px 4px rgba(120, 0, 170, 0.45), 0 0 0 1px rgba(255, 255, 255, 0.15), 0 0 12px rgba(255, 0, 255, 0.45)',
  '&:hover': {
    bgcolor: 'transparent',
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 2,
    left: 4,
    right: 4,
    height: '45%',
    borderRadius: '20px',
    background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.45), rgba(255, 255, 255, 0))',
    pointerEvents: 'none',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: '24px',
    boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.15), inset 0 -1px 0 rgba(0, 0, 0, 0.25)',
    pointerEvents: 'none',
  },
};

const tabLabelSx = {
  position: 'relative',
  zIndex: 1,
  color: '#fff',
  fontWeight: 700,
  fontSize: 16,
  lineHeight: 1,
  letterSpacing: '1px',
  textAlign: 'center',
  whiteSpace: 'nowrap',
};

export default function BazaarTopTabs({ value, onChange }) {
  return (
    <Box sx={tabNavSx}>
      {TAB_ORDER.map((tab) => {
        const isActive = tab === value;

        return (
          <Box
            key={tab}
            component="button"
            type="button"
            onClick={() => onChange(tab)}
            aria-pressed={isActive}
            sx={{
              ...tabBaseSx,
              ...(isActive ? tabActiveSx : {}),
            }}
          >
            <Typography component="span" sx={tabLabelSx}>
              {TAB_LABELS[tab]}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
